export const GoIcon = () => {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.469 4.375L16.094 10l-5.625 5.625M15.313 10H3.905"
        stroke="#125970"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
